import constants from '../constants';

export default (value) => constants.common.PUBLISH_PATH_RESERVED_REGEXP.test(value);
